<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <polygon points="24,6 33,17 27,17 27,28 21,28 21,17 15,17" fill="inherit"/>
        <rect x="10" y="36" width="4" height="6" fill="inherit"/>
        <rect x="34" y="36" width="4" height="6" fill="inherit"/>
        <rect x="10" y="38" width="28" height="4" fill="inherit"/>
    </svg>
</template>
